import { render, staticRenderFns } from "./ModalSistemasEServicos.vue?vue&type=template&id=735ba882&scoped=true"
import script from "./ModalSistemasEServicos.vue?vue&type=script&lang=js"
export * from "./ModalSistemasEServicos.vue?vue&type=script&lang=js"
import style0 from "./ModalSistemasEServicos.vue?vue&type=style&index=0&id=735ba882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735ba882",
  null
  
)

export default component.exports